import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, type IconName } from './Icon';

// Four-tab bottom nav. "Alerts" is a placeholder — it routes to
// /for-you for now so the tab is never a dead-end click. Wire it
// up when the alerts screen arrives.
type Tab = {
  to: string;
  i18nKey: string;
  icon: IconName;
  size?: number;
  dead?: boolean;     // true = shares another tab's route, don't light up when active
};

// Matches is the default/first tab. For You is second.
const TABS: Tab[] = [
  { to: '/matches', i18nKey: 'nav.matches', icon: 'matches' },
  { to: '/for-you', i18nKey: 'nav.forYou', icon: 'feed' },
  { to: '/for-you', i18nKey: 'nav.alerts', icon: 'bell', dead: true },
  { to: '/me', i18nKey: 'nav.me', icon: 'profile' },
];

export function TabBar() {
  const { t } = useTranslation();
  return (
    <nav className="mx-tabbar" aria-label="Primary">
      {TABS.map((tab, i) => (
        <NavLink
          key={`${tab.to}-${i}`}
          to={tab.to}
          className={({ isActive }) =>
            // Only light up tabs that own their route — the Alerts tab shares
            // /for-you and shouldn't glow alongside it.
            `mx-tab ${isActive && !tab.dead ? 'is-on' : ''}`
          }
          end
        >
          <Icon name={tab.icon} size={22} />
          {t(tab.i18nKey)}
        </NavLink>
      ))}
    </nav>
  );
}
